import React from "react";
import { Link } from "react-router-dom";
import { Pagination /* Button */ } from "zina-dogi-react";
// import { utils } from "~/utils";
// import { Badge } from "reactstrap";

const titles = [
    "Non SODE ID",
    "Non SODE Status",
    "Request Status",
    "Customer Team",
    "Material Type",
    "Circle",
    "OET ID",
    "OET Name",
    "OET Status",
    "Run ID",
    "Run Status"
];

const NonSODETable = ({ non_sodes, className, pagination }) => {
    return (
        <div {...{ className }}>
            <div className="table-content" style={{ overflowX: "auto" }}>
                <table className="table table-bordered table-striped">
                    <thead className="thead-dark">
                        <tr>
                            {titles &&
                                titles.map((title, index) => (
                                    <th key={`cpo_title_${index}`} scope="col">
                                        {title}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>{computeRows(non_sodes)}</tbody>
                </table>
            </div>
            <Pagination {...pagination} />
        </div>
    );
};

const computeRows = non_sodes => {
    if (non_sodes) {
        const non_sode_list = Object.values(non_sodes);
        if (non_sode_list.length !== 0) {
            return non_sode_list.map((row, index) => {
                return (
                    <tr key={`non_sode_value_${index}`}>
                        <td className="text-center">
                            {row.non_sode && row.cpo && <Link to={`/non-sode/${row.cpo.id}`}>#{row.non_sode.id}</Link>}
                        </td>
                        <td className="text-center">{row.cpo_register ? row.cpo_register.status_display : ""}</td>
                        <td className="text-center">{row.non_sode ? row.non_sode.status_display : ""}</td>
                        <td className="text-center">{row.customer_team ? row.customer_team.name : ""}</td>
                        <td className="text-center">{row.non_sode ? row.non_sode.material_type_display : ""}</td>
                        <td className="text-center">{row.cpo_register ? row.cpo_register.circle : null}</td>
                        <td className="text-center">
                            {row.oet ? <Link to={`/non-sode/oet/${row.oet.id}`}>{row.oet.id}</Link> : ""}
                        </td>
                        <td className="text-center">
                            {row.oet ? <Link to={`/non-sode/oet/${row.oet.id}`}>{row.oet.name}</Link> : ""}
                        </td>
                        <td className="text-center">{row.oet ? row.oet.status_display : ""}</td>
                        <td className="text-center">
                            {row.run && (
                                <Link to={`/non-sode/run/${row.oet.id}/${row.run.id}`}>
                                    {row.run.number ? `#${row.run.number}` : ""}
                                </Link>
                            )}
                        </td>
                        <td className="text-center">{row.run ? row.run.status_display : ""}</td>
                        {/*<td>*/}
                        {/*    {row.run && row.run.status_display}{" "}*/}
                        {/*    {row.run &&*/}
                        {/*        row.run.days_delayed > 0 && (*/}
                        {/*            <Badge*/}
                        {/*                color="danger"*/}
                        {/*                pill*/}
                        {/*                style={{ float: "right" }}*/}
                        {/*            >*/}
                        {/*                {row.run.days_delayed}*/}
                        {/*            </Badge>*/}
                        {/*        )}*/}
                        {/*</td>*/}
                    </tr>
                );
            });
        }
    }
    return (
        <tr>
            <td colSpan={titles.length}>No data found</td>
        </tr>
    );
};

export default NonSODETable;
